import { render, staticRenderFns } from "./WorkflowBox.vue?vue&type=template&id=7744a229&"
import script from "./WorkflowBox.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WorkflowBox.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports